import { createI18n, useI18n } from 'vue-i18n';
import { Constants, CountryUtil } from '@fibl/oxs-common';
import type { WebConf } from './boot';

let i18nInstance: ReturnType<typeof createI18n> | null = null;

export async function initTranslations(webconf: WebConf) {
	const lib = {};
	const web = webconf.website;
	switch (web) {
		case Constants.WEB_ADMIN: {
			const de = await import('@/assets/translation/de_DE.json');
			const admin = await import('@/assets/translation/admin.json');
			const merged = {};
			Object.assign(merged, de.default, admin.default);
			Object.assign(lib, { de: merged });
			break;
		}
		case Constants.WEB_OXS: {
			const country = webconf.country! as CountryUtil.CountryCode;
			switch (country) {
				case 'LU':
				case 'DE': {
					Object.assign(
						lib,
						{ de: (await import('@/assets/translation/de_DE.json')).default }
					);
					break;
				}
				case 'CH': {
					Object.assign(
						lib,
						{ de: (await import('@/assets/translation/de_CH.json')).default },
						{ fr: (await import('@/assets/translation/fr_CH.json')).default },
						{ it: (await import('@/assets/translation/it_IT.json')).default },
					);
					break;
				}
				case 'BE': {
					Object.assign(
						lib,
						{ de: (await import('@/assets/translation/de_DE.json')).default },
						{ fr: (await import('@/assets/translation/fr_FR.json')).default },
						{ nl: (await import('@/assets/translation/nl_BE.json')).default },
					);
				}
				case 'DK': {
					Object.assign(
						lib,
						{ da: (await import('@/assets/translation/da_DK.json')).default }
					);
					break;
				}
				case 'LT': {
					Object.assign(
						lib,
						{ lt: (await import('@/assets/translation/lt_LT.json')).default }
					);
					break;
				}
				case 'NL': {
					Object.assign(
						lib,
						{ nl: (await import('@/assets/translation/nl_NL.json')).default }
					);
					break;
				}
				case 'SE': {
					Object.assign(
						lib,
						{ sv: (await import('@/assets/translation/sv_SE.json')).default }
					);
					break;
				}
				default: {
					Object.assign(
						lib,
						{ en: (await import('@/assets/translation/en_GB.json')).default }
					);
				}
			}

			break;
		}
		case Constants.WEB_OXS_SELECT: {
			Object.assign(
				lib,
				{ en: (await import('@/assets/translation/en_GB.json')).default },
				{ de: (await import('@/assets/translation/de_DE.json')).default },
				{ fr: (await import('@/assets/translation/fr_FR.json')).default },
				{ it: (await import('@/assets/translation/it_IT.json')).default },
				{ sv: (await import('@/assets/translation/sv_SE.json')).default },
				{ nl: (await import('@/assets/translation/nl_NL.json')).default },
				{ da: (await import('@/assets/translation/da_DK.json')).default },
				{ lt: (await import('@/assets/translation/lt_LT.json')).default }
			);
			break;
		}
		case Constants.WEB_RDB: {
			const de = await import('@/assets/translation/de_DE.json');
			const en = await import('@/assets/translation/en_GB.json');
			const bg = await import('@/assets/translation/bg_BG.json');
			const cs = await import('@/assets/translation/cs_CZ.json');
			const da = await import('@/assets/translation/da_DK.json');
			const el = await import('@/assets/translation/el_GR.json');
			const es = await import('@/assets/translation/es_ES.json');
			const et = await import('@/assets/translation/et_EE.json');
			const fi = await import('@/assets/translation/fi_FI.json');
			const fr = await import('@/assets/translation/fr_FR.json');
			const hu = await import('@/assets/translation/hu_HU.json');
			const it = await import('@/assets/translation/it_IT.json');
			const lt = await import('@/assets/translation/lt_LT.json');
			const lv = await import('@/assets/translation/lv_LV.json');
			const nl = await import('@/assets/translation/nl_NL.json');
			const pl = await import('@/assets/translation/pl_PL.json');
			const pt = await import('@/assets/translation/pt_PT.json');
			const ro = await import('@/assets/translation/ro_RO.json');
			const sk = await import('@/assets/translation/sk_SK.json');
			const sl = await import('@/assets/translation/sl_SI.json');
			const sv = await import('@/assets/translation/sv_SE.json');
			Object.assign(
				lib,
				{ de: de.default },
				{ en: en.default },
				{ bg: bg.default },
				{ cs: cs.default },
				{ da: da.default },
				{ el: el.default },
				{ es: es.default },
				{ et: et.default },
				{ fi: fi.default },
				{ fr: fr.default },
				{ hu: hu.default },
				{ it: it.default },
				{ lt: lt.default },
				{ lv: lv.default },
				{ nl: nl.default },
				{ pl: pl.default },
				{ pt: pt.default },
				{ ro: ro.default },
				{ sk: sk.default },
				{ sl: sl.default },
				{ sv: sv.default },
			);
			break;
		}
	}
	// console.log('loading i18n', lib);
	i18nInstance = createI18n({
		locale: 'en',
		messages: lib,
		fallbackLocale: 'en',
	});

	return i18nInstance;
}

export function getI18n() {
	if (!i18nInstance) {
		throw new Error('i18n not initialized. Call initTranslations first.');
	}
	return i18nInstance.global as ReturnType<typeof useI18n>;
}
